import { AnchorDetails } from "../../../resources/modelTypes";
import { SectionComponentProps } from "../../types";
import { ActionLink } from "@minted/fancyclothes";
import React, { memo } from "react";

const DisplayWebsiteUrlSection = ({ section }: SectionComponentProps) => {
  const details = section.sectionDetails as AnchorDetails;

  return (
    <>
      {Boolean(details.anchorText && details.websiteUrl) && (
        <ActionLink
          target="_blank"
          text={details.anchorText}
          url={details.websiteUrl}
        />
      )}
    </>
  );
};

const MemoizedDisplayWebsiteUrl = memo(DisplayWebsiteUrlSection);

export { MemoizedDisplayWebsiteUrl as DisplayWebsiteUrlSection };
